const onlyNumbers = (inputText: string) => {
  return `${inputText}`.replace(/[^\d]/g, '');
};

const toNumber = (num: string) => {
  const numSanitize = `${num}`.split(',').join('.');
  return parseFloat(numSanitize);
};

export { toNumber, onlyNumbers };
